@if (loading) {
  <ntw-loading-panel></ntw-loading-panel>
} @else {
  <div class="container">
    <img src="../../assets/images/please choose the client.svg"
      alt="{{'selectAccount.imageAlternativeText' | translate }}" class="image" />
    <p class="title">{{'selectAccount.pleaseChooseTheClient' | translate }}</p>
  </div>
}
